import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../Header/Header";
import "../../assets/css/SubmitPage/SubmitPage.css";
import {
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";

import axios from "axios";
import { BASE_URL } from "../../store/config";

function SubmitPage() {

  // =========================================
  // HOOKS
  // =========================================
  const navigate = useNavigate();
  const { attemptId } = useParams();

  // =========================================
  // STATES
  // =========================================
  const [loading, setLoading] = useState(true);

  const [resultData, setResultData] = useState(null);

  const [showReview, setShowReview] = useState(false);

  // =========================================
  // FETCH RESULT
  // =========================================
  useEffect(() => {

    const fetchResult = async () => {

      try {

        const res = await axios.get(
          `${BASE_URL}api/attempts/${attemptId}/result`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );

        setResultData(res.data);

      } catch (err) {

        console.error("Result fetch error:", err);

      } finally {

        setLoading(false);
      }
    };

    fetchResult();

  }, [attemptId]);
  // =========================================
  // LOADING
  // =========================================
  if (loading) {
    return (
      <>
        <Header showProfile={true} />
 
        <div className="submit-container">
          <h2>Loading Result...</h2>
        </div>
      </>
    );
  }
 
  // =========================================
  // NO DATA
  // =========================================
  if (!resultData) {
    return (
      <>
        <Header showProfile={true} />
 
        <div className="submit-container">
 
          <h2>No Result Found</h2>
 
          <button onClick={() => navigate("/")}>
            Go Home
          </button>
 
        </div>
      </>
    );
  }
 
  // =========================================
  // EXTRACT DATA
  // =========================================
  const {
    assessment_title,
    score,
    total_score,
    percentage,
    pass_status,
    correct_answers,
    wrong_answers,
    skipped_answers,
    results,
  } = resultData;
 
  // =========================================
  // MAIN UI
  // =========================================
  return (
    <>
      <Header showProfile={true} />
 
      <div className="result-page">
 
        {/* ================================= */}
        {/* TOP SECTION */}
        {/* ================================= */}
        <div className="result-top">
 
          <div className="trophy">
            <img
              src="/assets/images/trophy.png"
              alt="Trophy"
            />
          </div>
 
          <h1>{assessment_title}</h1>
 
          <h2>Assessment Completed!</h2>
 
        </div>
 
        {/* ================================= */}
        {/* SCORE CARD */}
        {/* ================================= */}
        <div className="result-card">
 
          {/* PROGRESS CIRCLE */}
          <div className="progress-ring">
 
            <svg width="180" height="180">
 
              <circle
                cx="90"
                cy="90"
                r="80"
                className="bg"
              />
 
              <circle
                cx="90"
                cy="90"
                r="80"
                className="progress"
                style={{
                  strokeDasharray: 502,
                  strokeDashoffset:
                    502 - (502 * percentage) / 100,
                }}
              />
 
            </svg>
 
            <div className="score-text">
              {percentage}%
            </div>
 
          </div>
 
          {/* SCORE */}
          <h2>
            {score} / {total_score} Points
          </h2>
 
          {/* STATUS */}
          {pass_status ? (
            <div className="badge">
              ⭐ Passed Successfully
            </div>
          ) : (
            <div className="badge low-score">
              Keep practicing and try again.
            </div>
          )}
 
          {/* ================================= */}
          {/* STATS */}
          {/* ================================= */}
          <div className="stats">
 
            <div className="stat correct">
              <span>{correct_answers}</span>
              <p>Correct</p>
            </div>
 
            <div className="stat wrong">
              <span>{wrong_answers}</span>
              <p>Wrong</p>
            </div>
 
            <div className="stat skipped">
              <span>{skipped_answers}</span>
              <p>Skipped</p>
            </div>
 
          </div>
 
          {/* ================================= */}
          {/* PROGRESS BAR */}
          {/* ================================= */}
          <div className="progress-bar">
            <div
              style={{
                width: `${percentage}%`,
              }}
            />
          </div>
 
          {/* ================================= */}
          {/* BUTTONS */}
          {/* ================================= */}
          <div className="actions">
 
            {/* REVIEW */}
            <button
              className="review-btn"
              onClick={() =>
                setShowReview(!showReview)
              }
            >
              {showReview
                ? "Hide Review"
                : "Show Review"}
            </button>
 
            {/* CERTIFICATE */}
            {pass_status && (
              <button
                className="certificate-btn"
                onClick={() =>
                  navigate("/welcome", {
                    state: {
                      menu: "Certificate",
                      resultData,
                    },
                  })
                }
              >
                Get Certificate
              </button>
            )}
 
            {/* FEEDBACK */}
            <button
              className="feedback-btn"
              onClick={() =>
                navigate("/welcome", {
                  state: {
                    menu: "Feedback",
                  },
                })
              }
            >
              Feedback
            </button>
 
            {/* HOME */}
            <button
              className="home-btn"
              onClick={() =>
                navigate("/welcome")
              }
            >
              Home
            </button>
 
          </div>
 
        </div>
 
        {/* ================================= */}
        {/* REVIEW SECTION */}
        {/* ================================= */}
        {showReview && (
          <div
            className="review-modal-overlay"
            onClick={() => setShowReview(false)}
          >
            <div
              className="review-modal"
              onClick={(e) => e.stopPropagation()}
            >
 
              {/* HEADER */}
              <div className="review-modal-header">
                <h2 style={{ color: "white" }}>Answer Review</h2>
 
                <button
                  className="close-btn"
                  onClick={() => setShowReview(false)}
                >
                  ✕
                </button>
              </div>
 
              {/* BODY */}
              <div className="review-modal-body">
 
                {results.map((result, index) => (
                  <div
                    key={index}
                    className={`review-card ${result.is_correct ? "correct-card" : "wrong-card"
                      }`}
                  >
                    <h3>
                      Q{index + 1}.{" "}
                      <span
                        dangerouslySetInnerHTML={{
                          __html: result.question,
                        }}
                      />
                    </h3>
 
                    <p>
                      <strong>Your Answer:</strong> {result.user_answer}
                    </p>
 
                    <p>
                      <strong>Correct Answer:</strong> {result.correct_answer}
                    </p>
 
                    <p>
                      {result.is_correct ? "✔ Correct" : "✖ Wrong"}
                    </p>
 
                    <p>
                      <strong>Score Awarded:</strong> {result.score_awarded}
                    </p>
                  </div>
                ))}
 
              </div>
 
            </div>
 
          </div>
        )}
 
      </div>
    </>
  );
}
 
export default SubmitPage;